import { ApiError, httpClient } from './httpClient';
import {
  FeatureFlagKey,
  FeatureFlagsApiResponse,
  FeatureFlagUpdateResponse,
} from '../types/featureFlags';

const ensureSuccess = <T extends { success?: boolean; message?: string }>(payload: T) => {
  if (payload?.success === false) {
    throw new ApiError(payload.message || 'Feature flags API error', 400, payload);
  }
  return payload;
};

/**
 * Публичный эндпоинт — работает и для гостей (без авторизации).
 * Используется при бутстрапе и для форсированной перезагрузки после 503.
 */
export const getPublicFeatureFlags = async (): Promise<FeatureFlagsApiResponse> => {
  const response = await httpClient.request<FeatureFlagsApiResponse>('/feature-flags');
  return ensureSuccess(response);
};

/** То же содержимое, но с админским префиксом (требует JWT + роль administrator). */
export const getAdminFeatureFlags = async (): Promise<FeatureFlagsApiResponse> => {
  const response = await httpClient.request<FeatureFlagsApiResponse>('/admin/feature-flags');
  return ensureSuccess(response);
};

export interface UpdateFeatureFlagPayload {
  enabled: boolean;
  /** ≤500 символов; null/undefined → сбрасываем в дефолт. */
  reason?: string | null;
}

export const setAdminFeatureFlag = async (
  key: FeatureFlagKey,
  payload: UpdateFeatureFlagPayload,
): Promise<FeatureFlagUpdateResponse> => {
  const response = await httpClient.request<FeatureFlagUpdateResponse>(
    `/admin/feature-flags/${key}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        enabled: payload.enabled,
        reason: payload.reason ?? null,
      }),
    },
  );
  return ensureSuccess(response);
};

/** Массовое обновление: ключи, отсутствующие в теле, остаются без изменений. */
export const setAdminFeatureFlagsBulk = async (
  patch: Partial<Record<FeatureFlagKey, UpdateFeatureFlagPayload>>,
): Promise<FeatureFlagsApiResponse> => {
  const response = await httpClient.request<FeatureFlagsApiResponse>('/admin/feature-flags', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  });
  return ensureSuccess(response);
};
